const UnicityValidator = (value, data, propName, props) => {
  const { object } = props || {};
  const found = data && data.find(obj => (obj !== object) && (obj[propName] === value));
  if (!found) return null;
  return props.message || 'Must be unique';
};

const UNICITY_VALIDATOR_KEY = 'unicity';

const EmptyValidator = (value, data, propName, props) => {
  if (!value) {
    return props.message || 'Must not be empty';
  }
  return null;
};
const EMPTY_VALIDATOR = 'empty';

export {
  UnicityValidator,
  UNICITY_VALIDATOR_KEY,
  EmptyValidator,
  EMPTY_VALIDATOR,
};

